import type { FileRecord } from "@cohesive/api-client";
import { type Entity, getEntityData } from "@cohesive/ui-components";

/**
 * Public viewer URL for a published file record.
 * Backend stores `{host}/public/{id}`; the shell lives at `/view/public/{id}`.
 */
function resolveFileRecordViewerUrl(record: FileRecord): string | null {
  if (!record.published || !record.published_url) return null;
  return record.published_url.replace("/public/", "/view/public/");
}

/** External URL for "open in new tab" on canvas entity nodes. */
export function resolveCanvasEntityOpenTabUrl(entity: Entity): string | null {
  const d = getEntityData(entity) as Record<string, unknown>;

  if ("base" in entity && entity.base === "file") {
    return (d?.web_link as string) ?? null;
  }

  if ("base" in entity && entity.base === "file_record") {
    const rec = getEntityData(entity) as FileRecord;
    // Prefer source-site when present; otherwise the Cohesive public viewer
    // (not the canvas CDN object path used for card media / download).
    return rec?.origin_url ?? resolveFileRecordViewerUrl(rec) ?? null;
  }

  return (
    (d?.web_link as string) ??
    (d?.html_link as string) ??
    (d?.granola_url as string) ??
    (d?.url as string) ??
    null
  );
}

export function openCanvasEntityTabUrl(url: string): void {
  const href =
    url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  window.open(href, "_blank", "noopener,noreferrer");
}
